<template>
    <div>
        <CRow>
            <CCol sm="12" class="p-1">
                <CCard class="p-3 border-16px">
                    <h3 class="custom-20px-500">Summary Reports</h3>
                    <CRow class="mt-3">
                        <CCol sm="3">
                            <CCard class="bg-26224E p-20 border-16px p-2">
                                <div class="m-2">
                                    <img src="../assets/img/all/note.png" width="20px" />
                                    <h3 class="custom-16px-500 text-white text-left mt-2">Total Reports</h3>
                                    <h4 class="custom-24px-600 mt-2 text-white">{{ reportCount.toLocaleString() }}</h4>
                                </div>
                            </CCard>
    
                        </CCol>
                        <CCol sm="3">
                            <CCard class="p-20 border-16px p-2">
                                <div class="m-2">
                                    <img src="../assets/img/all/under.png" width="20px" />
                                    <h3 class="custom-16px-500 text-left mt-2">Under Investigation</h3>
                                    <h4 class="custom-24px-600 mt-2">0</h4>
                                </div>
                            </CCard>
                        </CCol>
                        <CCol sm="3">
                            <CCard class="p-20 border-16px p-2">
                                <div class="m-2">
                                    <img src="../assets/img/all/emergency.png" width="20px" />
                                    <h3 class="custom-16px-500 text-left mt-2">New Reports</h3>
                                    <h4 class="custom-24px-600 mt-2">0</h4>
                                </div>
                            </CCard>
    
                        </CCol>
                        <CCol sm="3">
                            <CCard class="p-20 border-16px p-2">
                                <div class="m-2">
                                    <img src="../assets/img/all/closed.png" width="20px" />
                                    <h3 class="custom-16px-500 text-left mt-2">Closed Reports</h3>
                                    <h4 class="custom-24px-600 mt-2">0</h4>
                                </div>
                            </CCard>
                        </CCol>
                    </CRow>
                </CCard>
            </CCol>
    
        </CRow>
        <CRow class="d-flex">
            <CCol sm="12" class="p-0">
                <CCard class="p-3 border-16px">
                    <h3 class="custom-20px-500">Recent Reports List</h3>
                    <table class="table table-responsive-sm mt-3">
                        <thead class="custom-E9E9ED p-4">
                            <th>
                                <h3 class="custom-14px-500">Report Number</h3>
                            </th>
                            <th>
                                <h3 class="custom-14px-500">Date</h3>
                            </th>
                            <!-- <th>
                                <h3 class="custom-14px-500">Time</h3>
                            </th> -->
                            <th>
                                <h3 class="custom-14px-500">Name</h3>
                            </th>
                            <th>
                                <h3 class="custom-14px-500">Type</h3>
                            </th>
                            <th>
                                <h3 class="custom-14px-500">Location</h3>
                            </th>
                            <th>
                                <h3 class="custom-14px-500">Status</h3>
                            </th>
                            <th></th>
                        </thead>
                        <tr v-for="item in reports" v-bind:key="item.ReportId">
                                <td>
                                    <h3 class="custom-14px-500 d-flex">{{ item.ReportId }}</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500 d-flex"><img src="../assets/img/smallicon/calendar-small.png" height="15px" class="mr-2" />{{ item.ReportDate | moment("DD/MM/YYYY") }}</h3>
                                </td>
                                <!-- <td>
                                    <h3 class="custom-14px-500">{{ item.ReportTime }}</h3>
                                </td> -->
                                <td>
                                    <h3 class="custom-14px-500">{{ item.FullName }}</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500"></h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">{{ item.Locations }}</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">
                                        <label class="custom-bg-new" style="display: flex; align-items: center; gap: 5px;">
                                            <img src="../assets/img/smallicon/circle-new.svg" width="10px"/>
                                            <span class="font-color-039855">New</span>
                                        </label>
                                    </h3>
                                </td>
                                <td>
                                    <CDropdown style="margin-left:7px" :caret="false">
                                        <template #toggler-content>
                                                        <img src="../assets/img/smallicon/3dot.png" width="20px">
</template>
                                        <CDropdownItem
                                            
                                            >
                                            <img src="../assets/img/smallicon/delete.png" width="20px" class="mr-2"/>Delete Report</CDropdownItem
                                        >
                                        <CDropdownItem
                                            @click="OpenEdit()"
                                            ><img src="../assets/img/smallicon/edit.png" width="20px" class="mr-2"/>Edit Report</CDropdownItem
                                        >
                                        <CDropdownItem
                                        @click="OpenView()"
                                            ><img src="../assets/img/smallicon/show.png" width="20px" class="mr-2"/>View Report</CDropdownItem
                                        >
                                    </CDropdown>
                                </td>
                            </tr>
                            <!-- <tr>
                                <td>
                                    <h3 class="custom-14px-500">RP-20250213-001</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500"><img src="../assets/img/smallicon/calendar-small.png" width="15px" class="mr-2" />12/11/2024</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">04:40 AM</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">John Smith</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">Theft</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">78 Elm St</h3>
                                </td>
                                <td>
                                    <h3 class="custom-14px-500">
                                        <label class="custom-bg-progress">
                                                <img src="../assets/img/smallicon/circle-progress.svg" width="10px"/> <span class="ml-2 font-color-FC7D5D">In Progress</span>
                                            </label>
                                    </h3>
                                </td>
                                <td> 
                                    <CDropdown style="margin-left:7px" :caret="false">
                                        <template #toggler-content>
                                                        <img src="../assets/img/smallicon/3dot.png" width="20px">
</template>
                                        <CDropdownItem
                                            
                                            >
                                            <img src="../assets/img/smallicon/delete.png" width="20px" class="mr-2"/>Delete Report</CDropdownItem
                                        >
                                        <CDropdownItem
                                            @click="OpenEdit()"
                                            ><img src="../assets/img/smallicon/edit.png" width="20px" class="mr-2"/>Edit Report</CDropdownItem
                                        >
                                        <CDropdownItem
                                        @click="OpenView()"
                                            ><img src="../assets/img/smallicon/show.png" width="20px" class="mr-2"/>View Report</CDropdownItem
                                        >
                                    </CDropdown></td>
                            </tr> -->
                        
                        </tbody>
                    </table>
                </CCard>
            </CCol>
           
        </CRow>

        <!-- <div v-if="isPopupView" class="popup-all backdrop-all">
            <div class="popup-all1">
                <CRow>
                    <CCol sm="10"><label class="custom-20px-600 font-color-171717">Case Details</label></CCol>
                    <CCol sm="2"> <img src="../assets/img/smallicon/close.png" style="max-width:15px;text-align:right" @click="closePopupView" /></CCol> 
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="4">
                        <h3 class="custom-16px-400 font-color-6C737F">Report Number</h3>
                    </CCol>
                    <CCol sm="8">
                        <h3 class="custom-16px-400 font-color-111927">RP-20250213-001</h3>
                    </CCol>
                    <hr />
                    <CCol sm="4">
                        <h3 class="custom-16px-400 font-color-6C737F">Report Name</h3>
                    </CCol>
                    <CCol sm="8">
                        <h3 class="custom-16px-400 font-color-111927">John Smith</h3>
                    </CCol>
                    <hr />
                    <CCol sm="4">
                        <h3 class="custom-16px-400 font-color-6C737F">Date</h3>
                    </CCol>
                    <CCol sm="8">
                        <h3 class="custom-16px-400 font-color-111927">2025-02-05 14:30</h3>
                    </CCol>
                    <hr />
                    <CCol sm="4">
                        <h3 class="custom-16px-400 font-color-6C737F">Incident Location</h3>
                    </CCol>
                    <CCol sm="8">
                        <h3 class="custom-16px-400 font-color-111927">Jalan Sultan Ismail, Kuala Lumpur</h3>
                    </CCol>
                    <hr />
                    <CCol sm="4">
                        <h3 class="custom-16px-400 font-color-6C737F">Incident Type</h3>
                    </CCol>
                    <CCol sm="8">
                        <h3 class="custom-16px-400 font-color-111927">Theft</h3>
                    </CCol>
                    <hr />
                    <CCol sm="4">
                        <h3 class="custom-16px-400 font-color-6C737F">Status</h3>
                    </CCol>
                    <CCol sm="8">
                       <h3 class="custom-14px-500">
                                        <label class="custom-bg-new">
                                                <img src="../assets/img/smallicon/circle-new.svg" width="10px"/> <span class="ml-2 font-color-039855">New</span>
                                            </label>
                                    </h3>
                    </CCol>
                </CRow>
                <CRow class="p-3">
                    <h3 class="custom-16px-400"> Supporting Evidence</h3>
                </CRow>
               
            </div>
        </div> -->

        <div v-if="isPopupEdit" class="popup-all backdrop-all">
            <div class="popup-all1">
                <CRow>
                    <CCol sm="10"><label class="custom-20px-600 font-color-171717">Edit Case Details</label></CCol>
                    <CCol sm="2"> <img src="../assets/img/smallicon/close.png" style="max-width:15px;text-align:right" @click="closePopupEdit" /></CCol> 
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="6">
                        <h3 class="custom-16px-400 font-color-6C737F">Report Number</h3>
                        <CInput type="text" />
                    </CCol>
                    <CCol sm="6">
                        <h3 class="custom-16px-400 font-color-6C737F">Report Name</h3>
                        <CInput type="text" />
                    </CCol>
                    <CCol sm="6">
                        <h3 class="custom-16px-400 font-color-6C737F">Date</h3>
                        <CInput type="text" />
                    </CCol>
                    <CCol sm="6">
                        <h3 class="custom-16px-400 font-color-6C737F">Incident Location</h3>
                        <CInput type="text" />
                    </CCol>
                    <CCol sm="6">
                        <h3 class="custom-16px-400 font-color-6C737F">Incident Type</h3>
                        <CInput type="text" />
                    </CCol>
                    <CCol sm="6">
                        <h3 class="custom-16px-400 font-color-6C737F">Status</h3>
                        <CInput type="text" />
                    </CCol>
                    <CCol sm="12">
                        <h3 class="custom-16px-400 font-color-6C737F">Report</h3>
                        <CTextarea type="text" rows="5"></CTextArea>
                    </CCol>
                </CRow>
                <CRow class="p-3">
                    <h3 class="custom-16px-400"> Supporting Evidence</h3>
                    <CCard>
                                            <div class="text-center file-upload-area" @dragover.prevent @drop="handleDrop" @click="triggerFileInput">
                                                <input type="file" ref="fileInput" multiple @change="handleFileSelect" style="display: none" />
                                                <br /><br /><br />
                                                <img src="../assets/img/uploadFile.png" width="50px" />
                                                <h3 class="custom-14px-600 text-center mt-3" style="color:#6941C6">
                                                Drag and drop your PDF file here, or click to select a file from your device.
                                                </h3>
                                                <h3 class="text-center custom-16px-400 font-color-696969">Maximum file size: 10 MB</h3>
                                                <br /><br /><br />
                                            </div>
                                            </CCard>
                </CRow>
               
            </div>
        </div>

        <div v-if="isPopupView" class="popup-all backdrop-all">
                <div class="popup-all2">
                    <div></div>
                    <CRow>
                        <CCol sm="11"><label class="custom-20px-600 font-color-171717">Details</label></CCol>
                        <CCol sm="1"> <img src="../assets/img/close.png" style="max-width:50px;text-align:right" @click="closePopupView" /></CCol>
                    </CRow>
                    <div class="custom-scroll">
                            <CRow>
                                <CCol sm="12">
                                   <img src="../assets/img/Video.jpg" style="max-width:100%" />
                             
                                <h4 class="custom-20px-600 font-color-171717 mt-4 m-2">Laporan pengadu</h4>
                                <CCard class="bg-FAFAFA mt-3 p-2" style="border:none">
                                    <p class="custom-18px-400 font-color-6C737F">
                                        Kemalangan yang telah berlaku di jalan keluar dari kawasan Putra Height ke lebuh raya.Saya memandu untuk masuk ke dalam jalan utama, kenderaan dari jalan utama memandu dengan agak laju dan saya tak dapat memasuki jalan tersebut sehingga di perhujungan simpang masuk menyebabkan saya terpaksa berhenti dengan mengejut. Ini telah menyebabkan motorsikal dari belakang melanggar saya walaupun dia telah menekan brek. Bumper kereta saya telah dilanggar dan dia telah jatuh ke bahu jalan. Sepertinya ada sedikit kecederaan yang tidak serius.
                                    </p>
                                </CCard>
                               <CRow>
                                 <CCol sm="6">
                                    <CCard class="bg-FAFAFA mt-3 p-2" style="border:none">

                                        <h4 class="custom-20px-500 font-color-171717">Kategori berdasarkan data pengadu:</h4>
                                        <h4 class="custom-40px-700 font-color-171717 text-left">Kesalahan: Trafik</h4>
                                        <h4 class="custom-20px-600 font-color-171717 mt-4">Skor Kesalahan Berdasarkan Kategori</h4>
                                        <p class="custom-14px-400">Lihat detail hasil analisis dalam satu laporan</p>
                                        <h3 class="custom-16px-500 text-left font-color-171717">Pemanduan Berbahaya</h3>
                                        <CRow>
                                            <CCol sm="10">
                                                <p class="custom-14px-400"> 70% (Pengadu terpaksa berhenti mengejut di simpang masuk, yang boleh dianggap sebagai pemanduan yang berisiko menyebabkan kemalangan) </p>
                                            </CCol>
                                            <CCol sm="2">7/10</CCol>
                                        </CRow>
                                      
                                        <CProgress :value="7" show-value color="danger" max="10" :animated="animate" class="mb-2" />

                                        <h3 class="custom-16px-500 text-left font-color-171717 mt-2">Tidak Mematuhi Lampu Isyarat</h3>
                                        <CRow>
                                            <CCol sm="10">
                                                <p class="custom-14px-400">0% (Tiada pelanggaran lampu isyarat dalam kes ini)   </p>
                                            </CCol>
                                            <CCol sm="2">0/10</CCol>
                                        </CRow>
                                      
                                        <CProgress :value="0" show-value color="success" max="10" :animated="animate" class="mb-2" />

                                        <h3 class="custom-16px-500 text-left font-color-171717 mt-2">Menggunakan Telefon Semasa Memandu </h3>
                                        <CRow>
                                            <CCol sm="10">
                                                <p class="custom-14px-400">0% (Tiada bukti pengadu menggunakan telefon semasa kejadian) </p>
                                            </CCol>
                                            <CCol sm="2">0/10</CCol>
                                        </CRow>
                                      
                                        <CProgress :value="0" show-value color="success" max="10" :animated="animate" class="mb-2" />

                                        <h3 class="custom-16px-500 text-left font-color-171717 mt-2"> Memandu Melebihi Had Laju </h3>
                                        <CRow>
                                            <CCol sm="10">
                                                <p class="custom-14px-400">0% (Pengadu tidak memandu laju, malah sedang memasuki jalan utama dengan berhati-hati)</p>
                                            </CCol>
                                            <CCol sm="2">0/10</CCol>
                                        </CRow>
                                      
                                        <CProgress :value="0" show-value color="success" max="10" :animated="animate" class="mb-2" />
                                    </CCard>
                                </CCol>
                                <CCol sm="6">
                                    <h4 class="custom-20px-600 m-2">Kesimpulan</h4>
                                    <CCard class="bg-FAFAFA mt-3 p-2" style="border:none">
                                       <p class="custom-18px-400"> Kesalahan utama yang mungkin boleh dikaitkan dengan pengadu adalah pemanduan berbahaya kerana berhenti secara mengejut di simpang masuk, yang menyebabkan motorsikal dari belakang melanggar bumper kereta. Namun, faktor utama yang membawa kepada kejadian ini juga melibatkan pemanduan laju oleh kenderaan di jalan utama, yang menyebabkan pengadu sukar memasuki jalan dengan selamat.</p>
                                    </CCard>


                                    <h4 class="custom-20px-600 m-2">Penerangan/Contoh Bagi Setiap Kesalahan</h4>
                                    <CCard class="bg-F1F0FF mt-3 p-2" style="border:none">
                                     
                                       <h3 class="custom-18px-700">1. Memandu di Bawah Pengaruh</h3>
                                       <p class="custom-18px-400">Memandu kenderaan semasa berada di bawah pengaruh alkohol atau dadah.</p>

                                       <h3 class="custom-18px-700">2. Pemanduan Berbahaya</h3>
                                       <p class="custom-18px-400">Memandu dengan cara yang membahayakan pengguna jalan raya lain.</p>


                                       <h3 class="custom-18px-700">3. Tidak Mematuhi Lampu Isyarat</h3>
                                       <p class="custom-18px-400">Melanggar lampu merah atau tidak berhenti di persimpangan yang mempunyai isyarat lalu lintas.</p>

                                       <h3 class="custom-18px-700">4. Pemanduan Berbahaya</h3>
                                       <p class="custom-18px-400">Menggunakan telefon bimbit ketika memandu tanpa alat bebas tangan, mengganggu tumpuan pemandu.</p>

                                       <h3 class="custom-18px-700">5. Memandu Melebihi Had Laju</h3>
                                       <p class="custom-18px-400">Memecut melebihi had laju yang ditetapkan, berisiko menyebabkan kemalangan serius.</p>
                                    
                                    </CCard>
                                </CCol>
                            </CRow>
                            <!-- <CCol sm="12">
                                <div class="text-center">
                            <CButton class="bg-26224E text-center text-white">Detail Analysis</CButton>
                        </div>
                            </CCol> -->
                            </CCol>

                            </CRow>
                    </div>
                    </div>
        </div>

        <div v-if="isPopupAnalysisView" class="popup-all backdrop-all">
            <div class="popup-all2">
                    <CRow>
                        <CCol sm="11"><label class="custom-20px-600 font-color-171717">Details</label></CCol>
                        <CCol sm="1"> <img src="../assets/img/close.png" style="max-width:50px;text-align:right" @click="closePopupView" /></CCol>
                    </CRow>
                    <div class="custom-scroll">
                            <CRow>
                                <CCol sm="12">
                                   <img src="../assets/img/smallicon/videoai.png" style="max-width:100%" />
                                </CCol>
                                <CCol sm="12">
                                </CCol>
                            </CRow>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


export default {
    components: {

    },
    data() {
        return {
            isPopupView: false,
            isPopupEdit: false,

            reports: [],
            reportCount: 0,
            isPopupAnalysisView:false
        };
    },

    mounted() {
        this.GetListReport();

    },
    methods: {
        closePopupView()
        {
            this.isPopupView = false;
        },
        OpenView()
        {
            this.isPopupView = true;
        },
        closePopupEdit()
        {
            this.isPopupEdit = false;
        },
        OpenEdit()
        {
            this.isPopupEdit = true;
        },
        handleDrop(event) {
            event.preventDefault();
            const files = Array.from(event.dataTransfer.files);
            this.processFiles(files);
        },
        processFiles(files) {
            files.forEach((file) => {
            if (file.size <= 10 * 1024 * 1024) { // 10MB Limit
            // Add the file to uploadedFiles only once, before uploading
            if (!this.uploadedFiles.some(f => f.name === file.name)) {
                this.uploadedFiles.push({ name: file.name, uploading: true });
                this.uploadFile(file); // Start the upload for this file
            }
            } else {
            alert("File size exceeds 10MB!");
            }
            });
        },
        GetListReport() {
            try {

                return this.$API
                .get(this.$GetAllReportDetails, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.reports = response.data;
                        this.reportCount = this.reports.length;
                    }
                });
            } catch (error) {
                console.log("eroor1" + response);
            }
        },


    }
};
</script>

<style scoped>
/* Ensures the card contains the map properly */

.map-container {
    position: relative;
    height: 250px;
    overflow: hidden;
}

/* Ensures the map wrapper fills its parent */

.map-wrapper {
    position: relative;
    width: 100%;
    height: 250px;
}

/* Forces Leaflet map to fully fit inside */

.full-map {
    width: 100%;
    height: 250px;
}

.leaflet-container {
    width: 100% !important;
    height: 100% !important;
    min-height: 250px;
    display: block;
}
</style>